import React from 'react';
import {
  NEWTESTCASE_DISNEY,
  NEWTESTCASE_ESPN,
  NEWTESTCASE_HULU,
  NEWTESTCASE_HULU_PLUS,
  NEWTESTCASE_OFFPLATFORM,
  NEWTESTCASE_NEWS_ENT,
  NEWTESTCASE_ROKU_FAST,
  NEWTESTCASE_FUBO,
} from '../../../../../testUtils';
import { CenteredDiv, LogoBtn, OffPlatformBtn, NewsEntBtn, RokuBtn, FuboBtn, HuluPlusBtn } from '../styles';
import huluLogo from '../../../../../../src/assets/Hulu.svg';
import dPlusLogo from '../../../../../assets/DisneyPlus.svg';
import espnLogo from '../../../../../../src/assets/Espn.svg';
import {
  DISNEY_PLUS_PUBLISHER,
  ESPN_PUBLISHER,
  HULU_PUBLISHER,
  HULU_PLUS_PUBLISHER,
  OFF_PLATFORM_PUBLISHER,
  NEWS_ENT_PUBLISHER,
  ROKU_FAST_PUBLISHER,
  FUBO_PUBLISHER,
  TRACE_DISNEY_PLUS_ACCOUNT,
  TRACE_HULU_ACCOUNT,
  TRACE_HULU_PLUS_ACCOUNT,
  TRACE_ESPN_ACCOUNT,
  TRACE_OFF_PLATFORM_ACCOUNT,
  TRACE_NEWS_ENT_ACCOUNT,
  TRACE_ROKU_ACCOUNT,
  TRACE_FUBO_ACCOUNT,
} from '../../../constants';

import { VIEW } from '../../../../../constants';

const PublisherSelector = ({ onPublisherSelect, permissions }) => {
  const PUBLISHER_CONFIG = [
    {
      permission: TRACE_DISNEY_PLUS_ACCOUNT,
      Component: LogoBtn,
      props: {
        onClick: () => onPublisherSelect(DISNEY_PLUS_PUBLISHER),
        src: dPlusLogo,
        alt: 'Add Disney Plus Account',
        'data-testid': NEWTESTCASE_DISNEY,
      },
      label: null,
    },
    {
      permission: TRACE_HULU_ACCOUNT,
      Component: LogoBtn,
      props: {
        onClick: () => onPublisherSelect(HULU_PUBLISHER),
        src: huluLogo,
        alt: 'Add Hulu Account',
        'data-testid': NEWTESTCASE_HULU,
      },
      label: null,
    },
    {
      permission: TRACE_HULU_PLUS_ACCOUNT,
      Component: HuluPlusBtn,
      props: {
        onClick: () => onPublisherSelect(HULU_PLUS_PUBLISHER),
        'data-testid': NEWTESTCASE_HULU_PLUS,
      },
      label: `Hulu+`,
    },
    {
      permission: TRACE_ESPN_ACCOUNT,
      Component: LogoBtn,
      props: {
        onClick: () => onPublisherSelect(ESPN_PUBLISHER),
        src: espnLogo,
        alt: 'Add ESPN Account',
        'data-testid': NEWTESTCASE_ESPN,
      },
      label: null,
    },
    {
      permission: TRACE_OFF_PLATFORM_ACCOUNT,
      Component: OffPlatformBtn,

      props: {
        onClick: () => onPublisherSelect(OFF_PLATFORM_PUBLISHER),

        'data-testid': NEWTESTCASE_OFFPLATFORM,
      },
      label: 'Off Platform',
    },
    {
      permission: TRACE_NEWS_ENT_ACCOUNT,
      Component: NewsEntBtn,
      props: {
        onClick: () => onPublisherSelect(NEWS_ENT_PUBLISHER),
        'data-testid': NEWTESTCASE_NEWS_ENT,
      },
      label: `News and\nEntertainment`,
    },
    {
      permission: TRACE_ROKU_ACCOUNT,
      Component: RokuBtn,
      props: {
        onClick: () => onPublisherSelect(ROKU_FAST_PUBLISHER),
        'data-testid': NEWTESTCASE_ROKU_FAST,
      },
      label: 'Roku FAST Channels',
    },
    {
      permission: TRACE_FUBO_ACCOUNT,
      Component: FuboBtn,
      props: {
        onClick: () => onPublisherSelect(FUBO_PUBLISHER),
        'data-testid': NEWTESTCASE_FUBO,
      },
      label: 'Fubo',
    },
  ];

  const allowedPublishers = PUBLISHER_CONFIG.filter(({ permission }) => permissions?.can?.(VIEW, permission));

  return (
    <CenteredDiv>
      {allowedPublishers.map(({ Component, props, label }, idx) => (
        <Component key={idx} {...props}>
          {label}
        </Component>
      ))}
    </CenteredDiv>
  );
};

export default PublisherSelector;
